// Single-tenant: the super-admin and firm users share one host, so super-admin
// status is determined from the authenticated user's role (set by the backend),
// not from the hostname/subdomain.
export const isSuperAdmin = () => {
  if (typeof window === "undefined") {
    return false;
  }

  try {
    const stored = JSON.parse(localStorage.getItem("user") || "null");
    return Array.isArray(stored?.roles) && stored.roles.includes("super-admin");
  } catch {
    return false;
  }
};
